<mat-card>
  <mat-card-title>Página no encontrada</mat-card-title>
  <mat-card-content>La página a la que está intentando acceder no existe.</mat-card-content>
  <mat-card-actions align="end">
    <a mat-raised-button color="primary" routerLink="/"><mat-icon>home</mat-icon>Ir al inicio</a>
  </mat-card-actions>
</mat-card>
